<template>
  <canvas ref="host"></canvas>
</template>

<script>
import { TileModel, defaultTilesLayer } from "vue-niney";

export default {
  name: "NTilesLayer",
  props: {
    layer: { type: Object, default: function() { return defaultTilesLayer }},
    loader: { type: Object },
    protocol: { type: String },
    tileWidth: { type: Number },
    tileHeight: { type: Number }
  },
  data: function() {
    return {
      boundsModel: null,
      focusModel: null
    }
  },
  mounted: function() {
    this.boundsModel = this.$parent.boundsModel;
    this.focusModel = this.$parent.focusModel;
    this.envelopeModel = this.$parent.envelopeModel;
    
    this.$refs.host.width = this.boundsModel.bounds.width;
    this.$refs.host.height = this.boundsModel.bounds.height;
    
    this.tileModel = new TileModel();
    this.tileModel.ctx = this.$refs.host.getContext("2d");
    this.tileModel.srs = this.focusModel.srs;
    this.tileModel.loader = this.loader;
    if (this.protocol != null) {
      this.tileModel.protocol = this.protocol;
    }
    if (this.tileWidth != null) {
      this.tileModel.tileWidth = parseInt(this.tileWidth);
    }
    if (this.tileHeight != null) {
      this.tileModel.tileHeight = parseInt(this.tileHeight);
    }
    this.tileModel.setBounds(this.boundsModel.bounds, this.envelopeModel? this.envelopeModel.getEnvelope(): null, this.envelopeModel? this.envelopeModel.getAnimationEnvelope(): null);
    this.tileModel.setCenterScale(this.focusModel.centerScale, this.envelopeModel? this.envelopeModel.getEnvelope(): null);
    this.tileModel.setAnimationCenterScale(this.focusModel.animationCenterScale, this.envelopeModel? this.envelopeModel.getAnimationEnvelope(): null);
    this.tileModel.setLayer(this.layer);
  },
  watch: {
    "$parent.boundsModel": function (val) {
      this.boundsModel = val;
    },
    "$parent.focusModel": function (val) {
      this.focusModel = val;
      this.tileModel.srs = val.srs;
    },
    "$parent.envelopeModel": function (val) {
      this.envelopeModel = val;
    },
    "boundsModel.bounds": function(val) {
      this.$refs.host.width = val.width;
      this.$refs.host.height = val.height;
      
      this.tileModel.setBounds(val, this.envelopeModel? this.envelopeModel.getEnvelope(): null, this.envelopeModel? this.envelopeModel.getAnimationEnvelope(): null);
    },
    "focusModel.centerScale": function(val) {
      this.tileModel.setCenterScale(val, this.envelopeModel? this.envelopeModel.getEnvelope(): null);
    },
    "focusModel.animationCenterScale": function(val) {
      this.tileModel.setAnimationCenterScale(val, this.envelopeModel? this.envelopeModel.getAnimationEnvelope(): null);
    },
    layer: function(val) {
      this.tileModel.setLayer(val);
    },
    "layer.visible": function(val) {
      this.tileModel.resetTiles();
    },
    loader: function(val) {
      this.tileModel.loader = val;
    },
    protocol: function(val) {
      if (val != null) {
        this.tileModel.protocol = val;
      }
    },
    tileWidth: function(val) {
      if (val != null) {
        this.tileModel.tileWidth = parseInt(val);
      }
    },
    tileHeight: function(val) {
      if (val != null) {
        this.tileModel.tileHeight = parseInt(val);
      }
    }
  }
}
</script>

<style scoped>
canvas {
  display: block;
  position: absolute;
  height: 100%;
}
</style>

